import { separator } from "./separator";

export const formatMoney = money => {
  if (money === 0) {
    return "Free";
  } else if (money === 1) {
    return "1 Toman";
  }
  return `${separator(money)} Tomans`;
};
